"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _lib = require("../lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RadioGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RadioGroup, _PureComponent);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var value = _ref.value;
      var disabled = _this.props.disabled;
      (0, _lib.callEventMethods)(e, 'persist');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      _this.setState({
        value: value
      }, function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          onChange(e, {
            name: name,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderChild", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          options = _this$props2.options,
          name = _this$props2.name,
          disabled = _this$props2.disabled,
          defaultValue = _this$props2.defaultValue,
          toggle = _this$props2.toggle,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          rest = _objectWithoutProperties(_this$props2, ["children", "options", "name", "disabled", "defaultValue", "toggle", "onChange", "value"]);

      return _react.Children.map(children, function (child) {
        if (!child.props) {
          return child;
        }

        var childProps = _objectSpread({}, rest, {
          name: name,
          toggle: toggle,
          radio: true,
          disabled: child.props.disabled || disabled,
          onChange: _this.handleOnChange,
          checked: child.props.value === _this.state.value,
          defaultChecked: child.props.value === defaultValue
        });

        return _react.default.cloneElement(child, childProps);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          options = _this$props3.options,
          name = _this$props3.name,
          disabled = _this$props3.disabled,
          defaultValue = _this$props3.defaultValue,
          toggle = _this$props3.toggle,
          onChange = _this$props3.onChange,
          value = _this$props3.value,
          rest = _objectWithoutProperties(_this$props3, ["children", "options", "name", "disabled", "defaultValue", "toggle", "onChange", "value"]);

      return options.map(function (option, idx) {
        var content = option.content,
            optRest = _objectWithoutProperties(option, ["content"]);

        return _react.default.createElement(_Checkbox.default, _extends({
          key: idx
        }, optRest, rest, {
          name: name,
          disabled: optRest.disabled || disabled,
          toggle: toggle,
          radio: true,
          onChange: _this.handleOnChange,
          checked: optRest.value === _this.state.value,
          defaultChecked: optRest.value === defaultValue
        }), content);
      });
    });

    var _value = props.value,
        _defaultValue = props.defaultValue;
    _this.state = {
      prevProps: {
        value: _value
      },
      // this only store props.value
      value: _value || _defaultValue
    };
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var options = this.props.options;

      if (options && (0, _lib.numberHasLength)(options.length)) {
        return this.renderOptions();
      }

      return this.renderChild();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value;
      return {
        // Store the previous props in state
        prevProps: {
          value: value
        },
        value: prevProps.value !== value ? value : state.value
      };
    }
  }]);

  return RadioGroup;
}(_react.PureComponent); // TODO: refine this


exports.default = RadioGroup;

_defineProperty(RadioGroup, "Option", _Checkbox.default);

_defineProperty(RadioGroup, "propTypes", {
  onChange: _propTypes.default.func,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  defaultValue: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.node,
  options: _propTypes.default.arrayOf(_propTypes.default.any),
  toggle: _propTypes.default.bool
});

_defineProperty(RadioGroup, "defaultProps", {
  onChange: null,
  value: null,
  defaultValue: null,
  disabled: false,
  children: null,
  toggle: false,
  options: []
});